module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "flows-creation-options"
    }
  }, [_c('router-link', {
    staticClass: "back-link-spaced",
    attrs: {
      "to": "/fluxos-de-cadencia"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowNew')))]), _c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.cadenceFlowNew')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "big-option-box"
  }, [_c('div', {
    staticClass: "big-option-box-icon paper-icon"
  }), _c('div', {
    staticClass: "big-option-box-title"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.emptyCadenceFlow')))]), _c('div', {
    staticClass: "big-option-box-text"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.createCadenceFlow')))]), _c('div', {
    staticClass: "big-option-box-select-wrapper"
  }, [_c('router-link', {
    staticClass: "btn btn-clean",
    attrs: {
      "to": "/fluxos-de-cadencia/criar"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.select')))])], 1)])]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "big-option-box"
  }, [_c('div', {
    staticClass: "big-option-box-icon folder-icon"
  }), _c('div', {
    staticClass: "big-option-box-title"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.fromLibCadenceFlow')))]), _c('div', {
    staticClass: "big-option-box-text"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.useCadenceFlow')))]), _c('div', {
    staticClass: "big-option-box-select-wrapper"
  }, [_c('router-link', {
    staticClass: "btn btn-clean",
    attrs: {
      "id": "flows-library",
      "to": "/fluxos-de-cadencia/biblioteca"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.select')))])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-803ac4d8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/creation_options.vue
// module id = 1182
// module chunks = 1